import axios from "../../../../api/axios";
import { Post } from "../../types/post.type";

import { CreatePostFormData } from "../types/feed.types";

export const likePost = async (postId: number) => {
  const response = await axios.patch(`/posts/${postId}/like`);
  return response.data;
};

export const unlikePost = async (postId: number) => {
  const response = await axios.patch(`/posts/${postId}/unlike`);
  return response.data;
};

export const repostPost = async (postId: number) => {
  const response = await axios.post(`/posts/${postId}/repost`);
  return response.data;
};

export const unrepostPost = async (postId: number) => {
  const response = await axios.delete(`/posts/${postId}/repost`);
  return response.data;
};

export const sharePost = async (postId: number, data: CreatePostFormData) => {
  const response = await axios.post(`/posts/${postId}/share`, data);
  return response.data;
};

export const createComment = async (body: { postId: number; text: string }) => {
  const response = await axios.post("/comments", body);
  return response.data;
};

export const createCommentReply = async (
  commentId: number,
  body: {
    text: string;
  }
) => {
  const response = await axios.post(`/comments/${commentId}/replies`, body);
  return response.data;
};

export const deleteComment = async (commentId: number) => {
  const response = await axios.delete(`/comments/${commentId}`);
  return response.data;
};

export const deletePost = async (postId: number) => {
  const response = await axios.delete(`/posts/${postId}`);
  return response.data;
};

export const createBasicPost = async (data: CreatePostFormData) => {
  const response = await axios.post("/posts/basic-post", data);
  return response.data;
};

export const updateBasicPost = async (postId: number, data: CreatePostFormData) => {
  const response = await axios.patch(`/posts/basic-post/${postId}`, data);
  return response.data;
};

export type PostDetailsData = {
  post: Post;
  mentionedUsers: number[];
};

export interface PostDetailsResponse {
  data: PostDetailsData;
  message: string;
}

export const getPostDetails = async (postId: number) => {
  try {
    const response = await axios.get<PostDetailsResponse>(`/posts/${postId}`);
    return response.data.data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message || err.message || "An unknown error occurred while fetching post details"
    );
  }
};
